export const SET_FILTER_TURNSTILE_COMMAND = 'SET_FILTER_TURNSTILE_COMMAND'
export const SET_FILTER_TURNSTILE_COMMAND_RESET = 'SET_FILTER_TURNSTILE_COMMAND_RESET'

const getTodayDateFrom = () => {
    let date = new Date().toISOString();
    return date.slice(0, date.indexOf("T")) + "T00:00";
}

const getTodayDateTo = () => {
    let date = new Date().toISOString();
    return date.slice(0, date.indexOf("T")) + "T23:59";
}

export const getDefaultCommandFilter = () => ({
    dateFrom: getTodayDateFrom(),
    dateTo: getTodayDateTo(),
});

export default function filterTurnstileCommand(
    state = {filterData: getDefaultCommandFilter()},
    action
) {
    switch (action.type) {
        case SET_FILTER_TURNSTILE_COMMAND:
            return {...state, filterData: action.payload};
        case SET_FILTER_TURNSTILE_COMMAND_RESET:
            return {...state, filterData: getDefaultCommandFilter()};
        default:
            return state;
    }
}
